module.exports = __webpack_public_path__ + "img/park-green-bg.baf4595f.webp";